
export default {
  props: {
    score: {
      type: Number,
      default: null,
    },
  },
  computed: {
    calculatedScore() {
      return this.score / 10 === 10
        ? this.score / 10
        : (this.score / 10).toFixed(1)
    },
  },
}
